export default __webpack_public_path__ + "static/media/pencil-white.492dba3c.svg";